// components/private/paket/hooks/usePackageTree.ts
import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";
import type { PackageItem } from "@/types/package";

/**
 * Fetch package tree for a given activePeriod
 * - enabled should be true only when user actually needs packageTree (role 2)
 * - caching: keep for 5 minutes (staleTime) to reduce re-fetch
 */
export function usePackageTree(activePeriodId?: number | null, enabled = false) {
    return useQuery<PackageItem[], Error>({
        queryKey: ["packages-tree", activePeriodId],
        queryFn: async () => {
            const { data } = await axiosClient.get<PackageItem[]>(
                `/packages/tree/${activePeriodId}`
            );
            return data;
        },
        enabled: Boolean(activePeriodId) && enabled,
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10,
        refetchOnWindowFocus: false,
        retry: 1,
    });
}
